import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { ERichCardType } from '..';
import { ScopedProvider } from '@lemon8/web-app-shared/ssr';
import { $CurrentPageModule } from '~/models/current-page-module';
import { ModuleType } from '~/utils/module-type';
import { $CurrentModuleRank } from '~/models/current-module-rank';
import { $CurrentPosition } from '~/models/current-position';
import { $CurrentAvailableDiscoverDataOrNull } from '~/routes/discover.$keyword/shared/atom';
import { formatSearchWords } from '~/components/search-words/util';
import { SearchWords } from '~/components/search-words';
import { TopicCard } from '~/components/topic-card';

export interface IImmersivePostRichCardProps {
  elementType: ERichCardType;
  elementInsertedPos: number;
  elementInnerIndex?: number;
}

export const ImmersivePostRichCard = (props: IImmersivePostRichCardProps): JSX.Element => {
  const data = useAtomValue($CurrentAvailableDiscoverDataOrNull);

  if (!data || !data.article_v2.items.length) {
    return <></>;
  }

  const { wordsMap } = useMemo(() => formatSearchWords(data.guessWordCards), [data]);
  const topics = data.hashtag.items.slice(0, 5);

  const { elementType, elementInsertedPos, elementInnerIndex = -1 } = props;

  const renderSearchWords = (): JSX.Element => {
    switch (elementType) {
      case ERichCardType.SEARCH_WORDS:
        return (
          <ScopedProvider
            atomsWithHydration={[
              [$CurrentPageModule, ModuleType.related_search],
              [$CurrentModuleRank, elementInsertedPos],
              [$CurrentPosition, ModuleType.related_search],
            ]}
          >
            <SearchWords words={wordsMap[elementInsertedPos]} className="in-immersive-post" />
          </ScopedProvider>
        );
      case ERichCardType.HASHTAG_CARD:
        return (
          <ScopedProvider
            atomsWithHydration={[
              [$CurrentPageModule, ModuleType.related_hashtag],
              [$CurrentModuleRank, elementInsertedPos],
            ]}
          >
            <TopicCard key={topics[elementInnerIndex].topicId} topic={topics[elementInnerIndex]} />
          </ScopedProvider>
        );
      default:
        return <></>;
    }
  };

  return renderSearchWords();
};
